import result from './result';
import vip from './vip';
import collectioninfo from './collectioninfo'
import membercollectioninfo from './membercollectioninfo'
import ciqaFolder from './ciqaFolder'
import ciqaFile from './ciqaFile'
import attachment from './attachment'
import piaochuang from './piaochuang'
export default {
    result,
    vip,
    collectioninfo,
    membercollectioninfo,
    ciqaFolder,
    ciqaFile,
    attachment,
    piaochuang
}